import * as React from 'react'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { Text } from '@amzn/dvui/dist/Text'
import { RecordRefTag } from '@utils'
import { RefmarkerTemplate } from '@amzn/dv-web-node-reftags'
import { ModalTrigger } from '../../utils/modalTrigger/ModalTrigger'
import CopyLinkButton from '../copyLinkButton/copyLinkButton'
import * as st from './shareWidget.module.scss'
import { ShareIcons } from './shareIcons/shareIcons'

export interface IShareModalProps {
  shareWidgetModel?: WpsRuntime.atv.wps.ShareWidgetModelProps
  refTag: RefmarkerTemplate
  pageType?: WpsRuntime.atv.wps.PageType
  subPageType?: WpsRuntime.atv.wps.SubPageType
}

// We give priority to the short url for the Copy Link button
const shareContent = ({ shareIcons, pageUrl, copyUrlReftag, copyLinkText, linkCopiedText, shortPageUrl }: WpsRuntime.atv.wps.ShareWidgetModelProps) =>
  <div>
    {shareIcons && <ShareIcons shareIcons={shareIcons} />}
    <CopyLinkButton url={shortPageUrl || pageUrl} reftag={copyUrlReftag} copyLinkText={copyLinkText} linkCopiedText={linkCopiedText} />
  </div>


const shareHeader = (headerText: string) =>
  <strong className={st.shareHeader}>
    <Text string={headerText}/>
  </strong>

export const ShareModalComp = ({ shareWidgetModel, refTag, pageType, subPageType }: IShareModalProps) => {

  return shareWidgetModel ?
    <ModalTrigger
      size='xs'
      modalHeader={shareHeader(shareWidgetModel.shareText)}
      modalContent={shareContent(shareWidgetModel)}
      modalId="share-modal"
      toggle={({ openModalClickHandler }) => (
        <RecordRefTag refTag={refTag} pageType={pageType} subPageType={subPageType}>
          <button id="shareTrigger" className={st.shareButton} onClick={openModalClickHandler}
                  data-automation-id="share-button" data-testid="share-button">
            <Text string={shareWidgetModel.shareText} />
          </button>
        </RecordRefTag>
      )}
      className={st.shareModal}
    /> : null
}

export const ShareModal = ShareModalComp
